module.exports = __webpack_public_path__ + "static/img/culture_03.b252a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investCenter/culture_03.png
// module id = dcxD
// module chunks = 0